module.exports = __webpack_public_path__ + "static/media/img_1.dbe19b3c.png";